'use strict';
define(['angular'], function (angular) {
    function Controller($scope, UserService, stAlertLimitService, stLimitMessage, userInfo, ExportService, $translate, $filter, __env, $timeout, $sce, $mdDialog, SerpCTRService, SERPChecker, $stateParams, TrackEventService) {
        function _constructor() {
            newAnalysis();
            setEventsListeners();
            attachComparisonScrollSync();
            //updateLimits();
        }

        var vm = $scope;
        vm.query = {
            mode: 'backlink',
            keyword: $stateParams.keyword || null,
            deviceId: parseInt($stateParams.deviceId, 10) || SERPChecker.config.defaultDeviceId,
            searchEngineId: SERPChecker.config.defaultSearchEngineId,
            countryCode: $stateParams.countryCode || SERPChecker.config.defaultCountryCode,
            benchmark: getBenchmarkFromStateParams() || []
        };

        var currentQueryParams = vm.query;
        var lastRequestParams = null;
        var lastRequestDone = null;

        var customTableController = {
            removeFixed: removeFixed,
            colorByScore: colorByScore,
            cleanUrl: cleanUrl,
            analyzeUrlBySeochecker: analyzeUrlBySeochecker,
            getColorGraphByScore: getColorGraphByScore,
            getFavIconURL: getFavIconURL,
            query: vm.query,
            getCTRByPosition: SerpCTRService.getCTRByPosition,
            hasValue: hasValue,
        };
        vm.cleanUrl = cleanUrl;
        vm.getFavIconURL = getFavIconURL;
        vm.getResultDisplayUrl = getResultDisplayUrl;
        vm.getResultHref = getResultHref;
        vm.getResolvedHref = getResolvedHref;
        vm.getResultFaviconUrl = getResultFaviconUrl;
        vm.getSourceFaviconUrl = getSourceFaviconUrl;
        vm.getAiOverviewSources = getAiOverviewSources;
        vm.getAiOverviewMarkdown = getAiOverviewMarkdown;
        vm.getResultSourceName = getResultSourceName;
        vm.getRelatedSearchHref = getRelatedSearchHref;
        vm.getResultDescription = getResultDescription;
        vm.getSerpItemText = getSerpItemText;
        vm.hasValue = hasValue;
        vm.aiOverviewHasOverflow = false;
        vm.isAiOverviewExpanded = false;
        vm.toggleAiOverview = toggleAiOverview;
        vm.localPackExpanded = false;
        vm.toggleLocalPack = toggleLocalPack;
        vm.getCTRByPosition = SerpCTRService.getCTRByPosition;
        vm.getSerpFeatureIcon = getSerpFeatureIcon;
        vm.serpView = 'results';
        vm.serpViewOptions = [
            {value: 'results', label: 'serpchecker.results.viewResults', icon: 'ti ti-list'},
            {value: 'snapshot', label: 'serpchecker.results.viewSnapshot', icon: 'ti ti-photo'}
        ];
        vm.setSerpView = setSerpView;
        var resultColumnDefaults = {
            pa: true,
            da: true,
            links: true,
            domains: true,
            traffic: true,
            ctr: true,
            dofollow: false,
            nofollow: false,
            dofollowRatio: false,
            linksPerDomain: false,
            engagement: false,
            reactions: false,
            comments: false,
            shares: false,
            rankPosition: false,
            featuresAbove: false,
            searchVolume: false
        };
        vm.resultColumns = angular.copy(resultColumnDefaults);
        vm.resultMetricGroups = createResultMetricGroups();
        vm.visibleExtraColumns = [];
        vm.syncVisibleResultExtraColumns = syncVisibleResultExtraColumns;
        syncVisibleResultExtraColumns();
        vm.formatResultExtraMetric = formatResultExtraMetric;
        vm.formatAiCitationExtraMetric = formatAiCitationExtraMetric;
        vm.getResultMetricLabel = getResultMetricLabel;
        vm.getResultMetricDescription = getResultMetricDescription;
        vm.openMetricsDialog = openMetricsDialog;
        vm.resultGridTemplate = resultGridTemplate;
        vm.resultGridMinWidth = resultGridMinWidth;
        vm.aiCitationGridTemplate = aiCitationGridTemplate;
        vm.aiCitationGridMinWidth = resultGridMinWidth;
        vm.getMetricRating = getMetricRating;
        vm.getAiCitationMetricRating = getAiCitationMetricRating;
        vm.getAiCitationCtr = getAiCitationCtr;
        vm.getAiCitationClicks = getAiCitationClicks;
        vm.getAiOverviewEstimatedClicks = getAiOverviewEstimatedClicks;
        vm.getSerpEstimatedClicks = getSerpEstimatedClicks;
        vm.refreshAnalysis = refreshAnalysis;
        vm.comparisonFooterSpacing = comparisonFooterSpacing;
        vm.clearFixedRows = clearFixedRows;
        vm.showSponsoredResults = true;
        vm.toggleSponsoredResults = toggleSponsoredResults;
        vm.aiOverviewCitations = [];
        vm.expandedAiCitations = {};
        vm.toggleAiCitation = toggleAiCitation;

        var settings = {
            setDevice: function (idDevice) {
                if (!idDevice) {
                    return;
                }
                var listDevice = [
                    {id: 1, name: 'desktop'}, {id: 2, name: 'mobile'}
                ];
                var device = listDevice.find(function (x) {
                    return x.id === idDevice;
                });
                if (device) {
                    return device.name;
                }
                return '';
            },
            setSearchEngine: function (idSearchEngine) {
                if (!idSearchEngine) {
                    return;
                }
                var listSearchEngine = [
                    {id: 1, name: 'google'}, {id: 2, name: 'yahoo'}, {id: 4, name: 'bing'}
                ];
                var searchEngine = listSearchEngine.find(function (x) {
                    return x.id === idSearchEngine;
                });
                if (searchEngine) {
                    return searchEngine.name;
                }
                return '';
            }
        };

        function setRowsForExportCSV(queries) {
            if (!queries.length) {
                return [];
            }
            var formattedQueriesForCSV = [];

            queries.forEach(function (query) {
                var formattedCSVRow = {
                    position: 0,
                    rankPosition: 0,
                    breadcrumb: '',
                    title: '',
                    device: 'desktop',

                    authority: 0,
                    domainAuthority: 0,
                    links: 0,
                    domains: 0,
                    noFollow: 0,
                    resultType: '',
                };

                if (!query) {
                    return;
                }

                formattedCSVRow.position = query.position;
                formattedCSVRow.rankPosition = query.rankPosition;
                formattedCSVRow.breadcrumb = query.breadcrumb;
                formattedCSVRow.resultType = query.resultType;
                formattedCSVRow.rankPosition = query.rankPosition;

                if (query.title && typeof query.title === 'string') {
                    formattedCSVRow.title = query.title.replace(',', '');
                }

                if (query.deviceId) {
                    formattedCSVRow.device = settings.setDevice(query.deviceId);
                }

                if (!query.extraParams) {
                    formattedQueriesForCSV.push(formattedCSVRow);
                    return;
                }

                formattedCSVRow.links = query.extraParams.backlinks || 0;
                formattedCSVRow.domains = query.extraParams.refdomains || 0;
                formattedCSVRow.noFollow = query.extraParams.nofollowBacklinks || 0;

                formattedQueriesForCSV.push(formattedCSVRow);
            });

            return formattedQueriesForCSV;
        }

        vm.results = {
            isLoading: false,
            competitorsRowsAreLoading: false,
            export: {
                stoTool: 'serp-report',
                class: 'st-button__rounded--md--violet',
                text: $translate.instant('keyword.exp.export.serp'),
                icon: 'icon-download',
                data: [],
                fileName: 'serp-keyword',
                buttonDisabled: true
            },
            controller: customTableController,
            rows: [],
            messages: {
                onBoarding: ''
            },
            fixedRows: []
        };
        vm.serpSnapshotItems = [];
        vm.dataForSeoResult = null;
        vm.serpSimulation = createEmptySimulation();

        vm.triggerExportCsvButton = function() {
            $timeout(function () {
                angular.element(document.querySelector('#export_csv_button button')).click();
                return;
            });
        }

        function updateLimits() {
            UserService.limits()
                .then(function (res) {
                    userInfo = res.data;
                    vm.analysisLimit = userInfo.limits.find(function (service) {
                        return service.alias === 'analysis';
                    });
                })
                .catch(function (err) {
                    console.log(err);
                    return null;
                });
        }

        function setSerpView(view) {
            vm.serpView = view === 'snapshot' ? 'snapshot' : 'results';
            $timeout(updateSerpOverflowStates, 0);
        }

        function resultGridTemplate() {
            var columns = ['42px', 'minmax(280px, 1fr)'];
            if (vm.resultColumns.traffic) columns.push('92px');
            if (vm.resultColumns.ctr) columns.push('105px');
            if (vm.resultColumns.pa) columns.push('52px');
            if (vm.resultColumns.da) columns.push('52px');
            if (vm.resultColumns.links) columns.push('88px');
            if (vm.resultColumns.domains) columns.push('82px');
            vm.visibleExtraColumns.forEach(function (column) {
                columns.push(column.width + 'px');
            });
            return columns.join(' ');
        }

        function resultGridMinWidth() {
            var width = 42 + 280;
            if (vm.resultColumns.traffic) width += 92;
            if (vm.resultColumns.ctr) width += 105;
            if (vm.resultColumns.pa) width += 52;
            if (vm.resultColumns.da) width += 52;
            if (vm.resultColumns.links) width += 88;
            if (vm.resultColumns.domains) width += 82;
            vm.visibleExtraColumns.forEach(function (column) {
                width += column.width;
            });
            return width + 'px';
        }

        function createResultMetricGroups() {
            return [
                {
                    label: 'serpchecker.results.metricsGroup.core',
                    options: [
                        {
                            key: 'traffic',
                            label: 'serpchecker.results.aiOverviewEstimatedClicks',
                            description: 'serpchecker.results.metricDescription.traffic'
                        },
                        {
                            key: 'ctr',
                            label: 'serpchecker.results.aiOverviewEstimatedCtr',
                            description: 'serpchecker.results.metricDescription.ctr'
                        },
                        {
                            key: 'pa',
                            label: 'PA',
                            description: 'serpchecker.results.metricDescription.pa'
                        },
                        {
                            key: 'da',
                            label: 'DA',
                            description: 'serpchecker.results.metricDescription.da'
                        },
                        {
                            key: 'links',
                            label: 'serpchecker.results.simulationLinks',
                            description: 'serpchecker.results.metricDescription.links'
                        },
                        {
                            key: 'domains',
                            label: 'serpchecker.results.simulationDomains',
                            description: 'serpchecker.results.metricDescription.domains'
                        }
                    ]
                },
                {
                    label: 'serpchecker.results.metricsGroup.backlinks',
                    options: [
                        {
                            key: 'dofollow',
                            label: 'serpchecker.results.metric.dofollow',
                            description: 'serpchecker.results.metricDescription.dofollow'
                        },
                        {
                            key: 'nofollow',
                            label: 'serpchecker.results.metric.nofollow',
                            description: 'serpchecker.results.metricDescription.nofollow'
                        },
                        {
                            key: 'dofollowRatio',
                            label: 'serpchecker.results.metric.dofollowRatio',
                            description: 'serpchecker.results.metricDescription.dofollowRatio'
                        },
                        {
                            key: 'linksPerDomain',
                            label: 'serpchecker.results.metric.linksPerDomain',
                            description: 'serpchecker.results.metricDescription.linksPerDomain'
                        }
                    ]
                },
                {
                    label: 'serpchecker.results.metricsGroup.social',
                    options: [
                        {
                            key: 'engagement',
                            label: 'serpchecker.results.metric.engagement',
                            description: 'serpchecker.results.metricDescription.engagement'
                        },
                        {
                            key: 'reactions',
                            label: 'serpchecker.results.metric.reactions',
                            description: 'serpchecker.results.metricDescription.reactions'
                        },
                        {
                            key: 'comments',
                            label: 'serpchecker.results.metric.comments',
                            description: 'serpchecker.results.metricDescription.comments'
                        },
                        {
                            key: 'shares',
                            label: 'serpchecker.results.metric.shares',
                            description: 'serpchecker.results.metricDescription.shares'
                        }
                    ]
                },
                {
                    label: 'serpchecker.results.metricsGroup.serp',
                    options: [
                        {
                            key: 'rankPosition',
                            label: 'serpchecker.results.metric.rankPosition',
                            description: 'serpchecker.results.metricDescription.rankPosition'
                        },
                        {
                            key: 'featuresAbove',
                            label: 'serpchecker.results.metric.featuresAbove',
                            description: 'serpchecker.results.metricDescription.featuresAbove'
                        },
                        {
                            key: 'searchVolume',
                            label: 'serpchecker.results.metric.searchVolume',
                            description: 'serpchecker.results.metricDescription.searchVolume'
                        }
                    ]
                }
            ];
        }

        function getResultExtraColumnDefinitions() {
            return [
                {key: 'dofollow', width: 78, format: 'compact', digits: 1},
                {key: 'nofollow', width: 78, format: 'compact', digits: 1},
                {key: 'dofollowRatio', width: 86, format: 'percent', digits: 1},
                {key: 'linksPerDomain', width: 86, format: 'decimal', digits: 2},
                {key: 'engagement', width: 86, format: 'compact', digits: 1},
                {key: 'reactions', width: 76, format: 'compact', digits: 1},
                {key: 'comments', width: 76, format: 'compact', digits: 1},
                {key: 'shares', width: 76, format: 'compact', digits: 1},
                {key: 'rankPosition', width: 78, format: 'rank'},
                {key: 'featuresAbove', width: 76, format: 'integer'},
                {key: 'searchVolume', width: 88, format: 'compact', digits: 2}
            ];
        }

        function syncVisibleResultExtraColumns() {
            vm.visibleExtraColumns = getResultExtraColumnDefinitions().filter(function (column) {
                return vm.resultColumns[column.key];
            });
        }

        function getResultMetricDefinition(key) {
            var definition = null;
            vm.resultMetricGroups.some(function (group) {
                definition = group.options.find(function (option) {
                    return option.key === key;
                });
                return !!definition;
            });
            return definition;
        }

        function getResultMetricLabel(key) {
            var definition = getResultMetricDefinition(key);
            return definition ? definition.label : key;
        }

        function getResultMetricDescription(key) {
            var definition = getResultMetricDefinition(key);
            return definition ? definition.description : key;
        }

        function getResultExtraValue(row, key) {
            var metrics = (row && row.metrics) || {};
            var performance = (row && row.performance) || {};
            var extraParams = (row && row.extraParams) || {};

            switch (key) {
                case 'dofollow':
                    return metrics.dofollowBacklinks !== undefined
                        ? metrics.dofollowBacklinks
                        : extraParams.dofollowBacklinks;
                case 'nofollow':
                    return metrics.nofollowBacklinks !== undefined
                        ? metrics.nofollowBacklinks
                        : extraParams.nofollowBacklinks;
                case 'dofollowRatio':
                    var dofollow = toNumber(metrics.dofollowBacklinks);
                    var backlinks = toNumber(metrics.backlinks);
                    return backlinks > 0 ? Number((dofollow * 100 / backlinks).toFixed(1)) : null;
                case 'linksPerDomain':
                    var linkCount = toNumber(metrics.backlinks);
                    var domainCount = toNumber(metrics.referringDomains);
                    return domainCount > 0 ? Number((linkCount / domainCount).toFixed(2)) : null;
                case 'engagement':
                    var engagementValues = [
                        toNullableNumber(metrics.reaction),
                        toNullableNumber(metrics.comment),
                        toNullableNumber(metrics.share)
                    ].filter(hasValue);
                    return engagementValues.length
                        ? engagementValues.reduce(function (sum, value) { return sum + value; }, 0)
                        : null;
                case 'reactions':
                    return metrics.reaction;
                case 'comments':
                    return metrics.comment;
                case 'shares':
                    return metrics.share;
                case 'rankPosition':
                    return row && Number(row.rankPosition) > 0
                        ? Number(row.rankPosition)
                        : null;
                case 'featuresAbove':
                    return performance.featuresAbove && performance.featuresAbove.length
                        ? performance.featuresAbove.length
                        : 0;
                case 'searchVolume':
                    return performance.searchVolume;
                default:
                    return null;
            }
        }

        function formatResultExtraMetric(row, column) {
            return formatColumnValue(getResultExtraValue(row, column.key), column);
        }

        function getAiCitationExtraValue(citation, key) {
            var metrics = (citation && citation.metrics) || citation || {};
            switch (key) {
                case 'dofollow':
                    return metrics.dofollowBacklinks;
                case 'nofollow':
                    return metrics.nofollowBacklinks;
                case 'dofollowRatio':
                    var dofollow = toNumber(metrics.dofollowBacklinks);
                    var backlinks = toNumber(metrics.backlinks);
                    return backlinks > 0 ? Number((dofollow * 100 / backlinks).toFixed(1)) : null;
                case 'linksPerDomain':
                    var linkCount = toNumber(metrics.backlinks);
                    var domainCount = toNumber(metrics.referringDomains);
                    return domainCount > 0 ? Number((linkCount / domainCount).toFixed(2)) : null;
                case 'engagement':
                    var engagementValues = [
                        toNullableNumber(metrics.reaction),
                        toNullableNumber(metrics.comment),
                        toNullableNumber(metrics.share)
                    ].filter(hasValue);
                    return engagementValues.length
                        ? engagementValues.reduce(function (sum, value) { return sum + value; }, 0)
                        : null;
                case 'reactions':
                    return metrics.reaction;
                case 'comments':
                    return metrics.comment;
                case 'shares':
                    return metrics.share;
                case 'searchVolume':
                    return vm.avgVolume;
                case 'rankPosition':
                case 'featuresAbove':
                default:
                    return null;
            }
        }

        function formatAiCitationExtraMetric(citation, column) {
            return formatColumnValue(getAiCitationExtraValue(citation, column.key), column);
        }

        function formatColumnValue(value, column) {
            if (!hasValue(value)) {
                return '—';
            }
            if (column.format === 'percent') {
                return $filter('number')(value, column.digits || 1) + '%';
            }
            if (column.format === 'rank') {
                return '#' + value;
            }
            if (column.format === 'decimal') {
                return $filter('number')(value, column.digits || 2);
            }
            if (column.format === 'integer') {
                return $filter('number')(value, 0);
            }
            return $filter('bigNumber')(value, column.digits || 1);
        }

        function toNumber(value) {
            if (!hasValue(value)) {
                return 0;
            }
            return Number(value) || 0;
        }

        function toNullableNumber(value) {
            return hasValue(value) ? Number(value) : null;
        }

        function openMetricsDialog(event) {
            $mdDialog.show({
                templateUrl: 'app/modules/serpchecker/dialogs/metrics/metrics.html',
                controller: 'SerpCheckerMetricsCtrl',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    metricGroups: vm.resultMetricGroups,
                    defaultColumns: angular.copy(resultColumnDefaults),
                    selectedColumns: angular.copy(vm.resultColumns)
                }
            }).then(function (selectedColumns) {
                Object.keys(resultColumnDefaults).forEach(function (key) {
                    vm.resultColumns[key] = selectedColumns[key] === true;
                });
                syncVisibleResultExtraColumns();
            });
        }

        function aiCitationGridTemplate() {
            return resultGridTemplate();
        }

        function comparisonFooterSpacing() {
            if (vm.serpView !== 'results' || !vm.results || !vm.results.fixedRows || !vm.results.fixedRows.length) {
                return null;
            }
            return (72 + (vm.results.fixedRows.length * 52)) + 'px';
        }

        function attachComparisonScrollSync() {
            function syncScroll(event) {
                var source = event.target;
                if (!source || !source.classList) {
                    return;
                }

                var resultsGrid;
                var resultsHeader;
                var comparisonScroller;
                if (source.classList.contains('serp-results-grid__body-scroller')) {
                    resultsGrid = source;
                    var resultsSection = resultsGrid.closest('.serp-results-grid');
                    resultsHeader = resultsSection
                        && resultsSection.querySelector('.serp-results-grid__header-scroller');
                    if (resultsSection && !resultsSection.classList.contains('serp-ai-citation-table')) {
                        comparisonScroller = document.querySelector('.serp-comparison-footer__scroller');
                    }
                } else if (source.classList.contains('serp-comparison-footer__scroller')) {
                    comparisonScroller = source;
                    resultsGrid = document.querySelector(
                        '.serp-results-grid:not(.serp-ai-citation-table) .serp-results-grid__body-scroller'
                    );
                    resultsHeader = resultsGrid
                        && resultsGrid.closest('.serp-results-grid')
                            .querySelector('.serp-results-grid__header-scroller');
                }

                if (!resultsGrid) {
                    return;
                }
                if (resultsHeader && resultsHeader.scrollLeft !== resultsGrid.scrollLeft) {
                    resultsHeader.scrollLeft = resultsGrid.scrollLeft;
                }
                if (comparisonScroller && comparisonScroller.scrollLeft !== resultsGrid.scrollLeft) {
                    comparisonScroller.scrollLeft = resultsGrid.scrollLeft;
                }
            }

            document.addEventListener('scroll', syncScroll, true);
            window.addEventListener('resize', updateSerpOverflowStates);
            vm.$on('$destroy', function () {
                document.removeEventListener('scroll', syncScroll, true);
                window.removeEventListener('resize', updateSerpOverflowStates);
            });
        }

        function updateSerpOverflowStates() {
            updateReadMoreLinks();
            updateAiOverviewOverflow();
        }

        function updateReadMoreLinks() {
            var descriptions = document.querySelectorAll('.serp-google-result__description-wrap');
            Array.prototype.forEach.call(descriptions, function (wrapper) {
                var text = wrapper.querySelector('.serp-google-result__description');
                if (!text) {
                    return;
                }
                wrapper.classList.remove('has-overflow');
                var lineHeight = parseFloat(window.getComputedStyle(text).lineHeight) || 22;
                if (text.scrollHeight > (lineHeight * 2) + 1) {
                    wrapper.classList.add('has-overflow');
                }
            });
        }

        function updateAiOverviewOverflow(attempts) {
            attempts = typeof attempts === 'number' ? attempts : 3;
            var bodies = document.querySelectorAll('.serp-ai-overview__body');
            var hasOverflow = false;
            var hasMeasurableBody = false;
            Array.prototype.forEach.call(bodies, function (body) {
                hasMeasurableBody = hasMeasurableBody || body.clientHeight > 0;
                if (body.classList.contains('is-expanded')) {
                    hasOverflow = body.classList.contains('has-overflow');
                    return;
                }
                body.classList.remove('has-overflow');
                if (body.scrollHeight > body.clientHeight + 1) {
                    body.classList.add('has-overflow');
                    hasOverflow = true;
                }
            });
            if ((!hasMeasurableBody || !hasOverflow) && attempts > 0) {
                $timeout(function () {
                    updateAiOverviewOverflow(attempts - 1);
                }, 100);
            }
            vm.aiOverviewHasOverflow = hasOverflow;
        }

        function toggleAiOverview() {
            vm.isAiOverviewExpanded = !vm.isAiOverviewExpanded;
            $timeout(updateAiOverviewOverflow, 0);
        }

        function toggleLocalPack() {
            vm.localPackExpanded = !vm.localPackExpanded;
        }

        function toggleAiCitation(citation) {
            if (!citation || !citation.url) {
                return;
            }
            vm.expandedAiCitations[citation.url] = !vm.expandedAiCitations[citation.url];
        }

        function refreshAnalysis() {
            lastRequestDone = null;
            lastRequestParams = null;
            vm.query.forceRefresh = true;
            newAnalysis();
            vm.query.forceRefresh = false;
        }

        function analyzeUrlBySeochecker(url) {
            return encodeURIComponent(btoa(url));
        }


        function getBenchmarkFromStateParams() {

            var stateParamsBenchmark = [];
            if ($stateParams.benchmark && isString($stateParams.benchmark))
                stateParamsBenchmark = [$stateParams.benchmark];
            if ($stateParams.benchmark && !isString($stateParams.benchmark) && $stateParams.benchmark.length)
                stateParamsBenchmark = $stateParams.benchmark;
            return stateParamsBenchmark;
        }


        function getFavIconURL(url) {
            return 'https://www.google.com/s2/favicons?sz=64&domain=' + url;
        }

        function getBreadcrumbUrl(row) {
            var breadcrumb = row && row.breadcrumb;
            if (!breadcrumb) {
                return '';
            }
            var match = String(breadcrumb).trim().match(/^https?:\/\/[^\s›]+/i);
            return match ? match[0].replace(/[),.;]+$/, '') : '';
        }

        function getHostnameFromUrl(url) {
            if (!url) {
                return '';
            }
            try {
                return new URL(url).hostname.replace(/^www\./i, '');
            } catch (error) {
                return '';
            }
        }

        function isGoogleHostname(hostname) {
            return /(^|\.)google\.[^/]+$/i.test(hostname || '');
        }

        function getResultDisplayUrl(row) {
            if (row && row.breadcrumb) {
                return row.breadcrumb;
            }
            return row && row.link && row.link.url ? cleanUrl(row.link.url) : '—';
        }

        function getResultDomain(row) {
            var snapshotData = row && row.extraParams && row.extraParams.snapshotData
                ? row.extraParams.snapshotData
                : {};
            var url = row && row.link && row.link.url;
            var urlHostname = getHostnameFromUrl(url);
            if (urlHostname && !isGoogleHostname(urlHostname)) {
                return cleanUrl(urlHostname);
            }

            var breadcrumbUrl = getBreadcrumbUrl(row);
            var breadcrumbHostname = getHostnameFromUrl(breadcrumbUrl);
            if (breadcrumbHostname && !isGoogleHostname(breadcrumbHostname)) {
                return cleanUrl(breadcrumbHostname);
            }
            if (snapshotData.domain && !isGoogleHostname(snapshotData.domain)) {
                return cleanUrl(snapshotData.domain);
            }
            if (snapshotData.domain) {
                return cleanUrl(snapshotData.domain);
            }
            return urlHostname ? cleanUrl(urlHostname) : '';
        }

        function getResultFaviconUrl(row) {
            var domain = getResultDomain(row);
            return domain ? getFavIconURL(domain) : '';
        }

        function getSourceFaviconUrl(url, domain) {
            var hostname = getHostnameFromUrl(getResolvedHref(url, domain));
            return hostname && !isGoogleHostname(hostname)
                ? getFavIconURL(hostname)
                : '';
        }

        function getAiOverviewSources(block) {
            var seen = {};
            return ((block && block.links) || [])
                .concat((block && block.references) || [])
                .filter(function (source) {
                    var label = source && (
                        source.title || source.source || source.domain || source.url
                    );
                    var key = getResolvedHref(source && source.url, source && source.domain)
                        + '|' + label;
                    if (!source || seen[key]) {
                        return false;
                    }
                    seen[key] = true;
                    return true;
                });
        }

        function escapeSerpHtml(value) {
            return String(value || '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        }

        function getAiOverviewSource(block, url) {
            var resolvedUrl = getResolvedHref(url);
            return ((block && block.references) || [])
                .concat((block && block.links) || [])
                .find(function (source) {
                    return source && getResolvedHref(source.url, source.domain) === resolvedUrl;
                }) || null;
        }

        function renderAiOverviewCitation(block, url, index) {
            var source = getAiOverviewSource(block, url);
            var domain = source && source.domain;
            var href = getResolvedHref(url, domain);
            if (!/^https?:\/\//i.test(href)) {
                return escapeSerpHtml('[' + index + ']');
            }
            var label = source && (source.source || source.title || source.domain);
            if (!label) {
                label = getHostnameFromUrl(href) || ('Fonte ' + index);
            }
            var favicon = source
                ? getSourceFaviconUrl(source.url, domain)
                : getSourceFaviconUrl(href);
            return '<a class="serp-ai-overview__citation" '
                + 'href="' + escapeSerpHtml(href) + '" '
                + 'target="_blank" rel="noopener noreferrer" '
                + 'aria-label="' + escapeSerpHtml(label) + '">'
                + (favicon
                    ? '<img src="' + escapeSerpHtml(favicon) + '" alt="" loading="lazy">'
                    : '')
                + '<span>' + escapeSerpHtml(label) + '</span>'
                + '</a>';
        }

        function renderAiOverviewInline(block, text) {
            var value = String(text || '');
            var output = '';
            var lastIndex = 0;
            var pattern = /\[\[(\d+)\]\]\(([^)\s]+)\)|\[([^\]]+)\]\(([^)\s]+)\)|\*\*([^*]+)\*\*/g;
            var match;

            while ((match = pattern.exec(value))) {
                output += escapeSerpHtml(value.slice(lastIndex, match.index));
                if (match[2]) {
                    output += renderAiOverviewCitation(block, match[2], match[1]);
                } else if (match[4]) {
                    var href = getResolvedHref(match[4]);
                    output += /^https?:\/\//i.test(href)
                        ? '<a href="' + escapeSerpHtml(href) + '" target="_blank" '
                            + 'rel="noopener noreferrer">' + escapeSerpHtml(match[3]) + '</a>'
                        : escapeSerpHtml(match[3]);
                } else {
                    output += '<strong>' + escapeSerpHtml(match[5]) + '</strong>';
                }
                lastIndex = pattern.lastIndex;
            }

            return output + escapeSerpHtml(value.slice(lastIndex));
        }

        function closeAiOverviewList(output, state) {
            if (state.listOpen) {
                output.push('</ul>');
                state.listOpen = false;
            }
        }

        function getAiOverviewMarkdown(block) {
            var markdown = block && block.markdown;
            if (!markdown) {
                return null;
            }
            if (block._aiOverviewMarkdownSource === markdown) {
                return block._aiOverviewMarkdownHtml;
            }

            var output = [];
            var state = {listOpen: false};
            String(markdown).replace(/\r\n/g, '\n').split('\n').forEach(function (line) {
                var trimmed = line.trim();
                var heading = trimmed.match(/^#{1,6}\s+(.+)$/);
                var listItem = trimmed.match(/^[-*]\s+(.+)$/);

                if (!trimmed) {
                    closeAiOverviewList(output, state);
                    return;
                }
                if (heading) {
                    closeAiOverviewList(output, state);
                    output.push('<h3 class="serp-ai-overview__subheading">'
                        + renderAiOverviewInline(block, heading[1])
                        + '</h3>');
                    return;
                }
                if (listItem) {
                    if (!state.listOpen) {
                        output.push('<ul>');
                        state.listOpen = true;
                    }
                    output.push('<li>' + renderAiOverviewInline(block, listItem[1]) + '</li>');
                    return;
                }
                closeAiOverviewList(output, state);
                output.push('<p>' + renderAiOverviewInline(block, trimmed) + '</p>');
            });
            closeAiOverviewList(output, state);

            block._aiOverviewMarkdownSource = markdown;
            block._aiOverviewMarkdownHtml = $sce.trustAsHtml(output.join(''));
            return block._aiOverviewMarkdownHtml;
        }

        function getResultSourceName(row) {
            var snapshotData = row && row.extraParams && row.extraParams.snapshotData
                ? row.extraParams.snapshotData
                : {};
            return snapshotData.website_name || getResultDomain(row);
        }

        function getResultDescription(row) {
            var snapshotData = row && row.extraParams && row.extraParams.snapshotData
                ? row.extraParams.snapshotData
                : {};
            var seen = {};
            return [
                snapshotData.pre_snippet,
                row && row.description,
                snapshotData.description,
                snapshotData.snippet,
                snapshotData.extended_snippet
            ].filter(function (part) {
                var text = part && String(part).replace(/\s+/g, ' ').trim();
                if (!text || seen[text]) {
                    return false;
                }
                seen[text] = true;
                return true;
            }).join(' ');
        }

        function getSerpItemText(item) {
            if (typeof item === 'string' || typeof item === 'number') {
                return String(item);
            }
            if (!item || typeof item !== 'object') {
                return '';
            }
            return item.title
                || item.name
                || item.text
                || item.description
                || item.snippet
                || item.domain
                || item.url
                || '';
        }

        function getRelatedSearchHref(item) {
            if (item && typeof item === 'object' && item.url) {
                return getResolvedHref(item.url, item.domain);
            }
            const query = getSerpItemText(item);
            return query
                ? `https://www.google.com/search?q=${encodeURIComponent(query)}`
                : 'https://www.google.com/search';
        }

        function getResultHref(row) {
            var url = row && row.link && row.link.url;
            var snapshotData = row && row.extraParams && row.extraParams.snapshotData
                ? row.extraParams.snapshotData
                : {};
            var href = getResolvedHref(url, snapshotData.domain);
            var parsed;
            try {
                parsed = new URL(href);
            } catch (error) {
                return href;
            }
            if (isGoogleHostname(parsed.hostname)
                && (parsed.pathname === '/' || !parsed.pathname)) {
                var breadcrumbUrl = getBreadcrumbUrl(row);
                if (breadcrumbUrl && !isGoogleHostname(getHostnameFromUrl(breadcrumbUrl))) {
                    return breadcrumbUrl;
                }
            }
            return href;
        }

        function getResolvedHref(url, domain) {
            if (!url) {
                return '';
            }
            try {
                var parsed = new URL(url);
                if (/(^|\.)google\.[^/]+$/i.test(parsed.hostname)
                    && (parsed.pathname === '/goto' || parsed.pathname === '/url')) {
                    var redirectKeys = ['url', 'q', 'u'];
                    for (var index = 0; index < redirectKeys.length; index += 1) {
                        var candidate = parsed.searchParams.get(redirectKeys[index]);
                        if (candidate) {
                            try {
                                candidate = decodeURIComponent(candidate);
                            } catch (error) {
                                // Keep the undecoded candidate when necessary.
                            }
                            if (/^https?:\/\//i.test(candidate)) {
                                return candidate;
                            }
                        }
                    }
                    if (domain) {
                        return 'https://' + String(domain)
                            .replace(/^https?:\/\//i, '')
                            .replace(/\/.*$/, '');
                    }
                }
            } catch (error) {
                // Relative URLs are normalized below.
            }
            if (/^https?:\/\//i.test(url)) {
                return url;
            }
            return url.indexOf('//') === 0 ? 'https:' + url : 'https://' + url;
        }

        function getSerpFeatureIcon(feature) {
            var icons = {
                paid: 'ti-ad-2',
                answer_box: 'ti-message-question',
                carousel: 'ti-carousel-horizontal',
                multi_carousel: 'ti-layout-grid',
                featured_snippet: 'ti-align-box-left-top',
                ai_overview: 'ti-sparkles',
                google_flights: 'ti-plane',
                google_reviews: 'ti-stars',
                third_party_reviews: 'ti-stars',
                hotels_pack: 'ti-building-hotel',
                google_hotels: 'ti-building',
                knowledge_graph: 'ti-building',
                images: 'ti-photo',
                local_pack: 'ti-map-pin',
                local_services: 'ti-tools',
                map: 'ti-map',
                people_also_ask: 'ti-help-circle',
                people_also_search: 'ti-users',
                related_searches: 'ti-search',
                shopping: 'ti-shopping-bag',
                events: 'ti-calendar-event',
                twitter: 'ti-brand-x',
                video: 'ti-video',
                short_videos: 'ti-player-play',
                top_stories: 'ti-news',
                jobs: 'ti-briefcase',
                recipes: 'ti-chef-hat',
                top_sights: 'ti-building-monument',
                scholarly_articles: 'ti-book',
                popular_products: 'ti-shopping-cart',
                product_considerations: 'ti-list-details',
                questions_and_answers: 'ti-messages',
                discussions_and_forums: 'ti-messages',
                perspectives: 'ti-users-group',
                find_results_on: 'ti-search',
                stocks_box: 'ti-chart-line',
                commercial_units: 'ti-building-store',
                math_solver: 'ti-math',
                currency_box: 'ti-currency-dollar',
                refine_products: 'ti-filter',
                compare_sites: 'ti-columns',
                app: 'ti-apps'
            };
            return icons[feature] || 'ti-sparkles';
        }

        function hasValue(value) {
            return value !== null
                && value !== undefined
                && value !== ''
                && !Number.isNaN(Number(value));
        }

        function getColorGraphByScore(score) {
            score = parseFloat(score);
            return [score >= 75 ? "#28b670" :
                score >= 50 ? "#fb8c00" :
                    "#f44336"];
        }

        function cleanUrl(url) {
            url = url.replace('https://', '');
            url = url.replace('http://', '');
            url = url.replace('www.', '');
            url = url.replace(/^www\./i, '');
            url = url.replace(/\/$/i, '');
            return url.trim();
        }


        function removeFixed(index) {
            vm.results.fixedRows.splice(index, 1);
            vm.$emit('SERPCheckerOnCompetitorsChanged', index);
        }

        function clearFixedRows() {
            vm.results.fixedRows = [];
            vm.$emit('SERPCheckerOnCompetitorsChanged', null);
        }


        function colorByScore(score) {
            function rgbify(maxval, minval, val) {
                val -= 13;
                if (val < 0) val = 0;
                var intnsty = (val - minval) / (maxval - minval);
                intnsty -= 0.005;
                if (intnsty < 0) intnsty = 0;
                var r, g;
                if (intnsty > 0.5) {
                    r = 240;
                    g = Math.round(2 * (1 - intnsty) * 195);
                } else {
                    g = 200;
                    r = Math.round(2 * intnsty * 235);
                }
                return "rgb(" + r.toString() + ", " + g.toString() + ", 100 , 0.38)";
            }

            return rgbify(100, 0, score);
        }

        function setLoadingState() {
            vm.results.isLoading = true;
            vm.serpSimulation = createEmptySimulation();
            vm.results.competitorsRowsAreLoading = false;
            vm.results.export.buttonDisabled = true;
            vm.backlinksAvg = null;
            vm.searchResults = null;
            vm.serpFeaturesList = null;
            vm.avgDifficulty = null;
            vm.avgVolume = null;
            vm.avgRefDomains = null;
            vm.backlinksTotal = null;
            vm.backlinksNoFollow = null;
            vm.backlinksDoFollow = null;
            vm.serpFeaturePositions = null;
            vm.serpSnapshotItems = [];
            vm.dataForSeoResult = null;
            vm.aiOverviewCitations = [];
            vm.expandedAiCitations = {};
            vm.showSponsoredResults = true;
        }

        function createEmptySimulation() {
            return {
                flow: [],
                organicCount: 0,
                featureCount: 0,
                knowledgeFeature: null,
                aiOverview: null,
                sideItems: [],
                sponsoredRows: [],
                questions: []
            };
        }

        function buildSerpSimulation(rows, resultFeatures, serpItems) {
            var organicRows = [];
            var paidRows = [];
            var flow = [];
            var renderedFeatures = [];
            var sideItems = [];
            var sponsoredRows = [];
            var aiOverviewFeature = null;
            var fallbackFeaturePositions = {
                featured_snippet: 1,
                app: 1,
                local_pack: 2,
                events: 3,
                people_also_ask: 4,
                video: 4,
                shopping: 5,
                images: 7,
                twitter: 9
            };

            (rows || []).forEach(function (row) {
                if (!row || !row.resultType) {
                    return;
                }
                if (row.resultType.indexOf('paid') !== -1) {
                    paidRows.push(row);
                } else if (row.resultType.indexOf('organic') !== -1) {
                    organicRows.push(row);
                }
            });

            var features = Array.isArray(resultFeatures) && resultFeatures.length
                ? resultFeatures
                : Array.isArray(serpItems) && serpItems.length
                    ? serpItems.filter(function (item) {
                        return item && item.type !== 'organic' && item.type !== 'paid';
                    })
                    : (vm.serpFeaturesList || [])
                        .filter(function (type) {
                            return type !== 'organic' && type !== 'paid' && type !== 'knowledge_graph';
                        })
                        .map(function (type) {
                            return {
                                type: type,
                                rankAbsolute: fallbackFeaturePositions[type] || 8,
                                items: []
                            };
                        });
            var knowledgeFeature = features.find(function (feature) {
                return feature && feature.type === 'knowledge_graph';
            }) || null;
            if (Number(vm.query.deviceId) === 2) {
                knowledgeFeature = null;
            }

            var sourceItems = Array.isArray(serpItems) && serpItems.length
                ? serpItems.slice().sort(function (left, right) {
                    return getSourceIndex(left) - getSourceIndex(right);
                })
                : null;
            var rowsBySourceIndex = {};
            rows.forEach(function (row) {
                var sourceIndex = getSerpItemSequence(row);
                if (sourceIndex < 999) {
                    rowsBySourceIndex[sourceIndex] = row;
                }
            });

            applyMetricRatings(organicRows.concat(paidRows));

            if (sourceItems) {
                for (var sourcePosition = 0; sourcePosition < sourceItems.length; sourcePosition += 1) {
                    var sourceItem = sourceItems[sourcePosition];
                    if (!sourceItem || !sourceItem.type) {
                        continue;
                    }

                    if (sourceItem.type === 'ai_overview' && !aiOverviewFeature) {
                        aiOverviewFeature = sourceItem;
                        continue;
                    }

                    if (sourceItem.type === 'knowledge_graph') {
                        if (Number(vm.query.deviceId) !== 2) {
                            if (!knowledgeFeature) {
                                knowledgeFeature = sourceItem;
                            }
                            continue;
                        }
                        renderedFeatures.push(sourceItem);
                        flow.push({
                            kind: 'feature',
                            order: getFeatureOrder(sourceItem, fallbackFeaturePositions),
                            sequence: getSourceIndex(sourceItem),
                            feature: sourceItem
                        });
                        continue;
                    }

                    if (sourceItem.type === 'local_pack') {
                        var localPackItems = [sourceItem];
                        while (
                            sourcePosition + 1 < sourceItems.length
                            && sourceItems[sourcePosition + 1]
                            && sourceItems[sourcePosition + 1].type === 'local_pack'
                        ) {
                            sourcePosition += 1;
                            localPackItems.push(sourceItems[sourcePosition]);
                        }
                        var localPackFeature = mergeLocalPackItems(localPackItems);
                        renderedFeatures.push(localPackFeature);
                        flow.push({
                            kind: 'feature',
                            order: getFeatureOrder(localPackFeature, fallbackFeaturePositions),
                            sequence: getSourceIndex(localPackFeature),
                            feature: localPackFeature
                        });
                        continue;
                    }

                    if (sourceItem.type === 'organic' || sourceItem.type === 'paid') {
                        var isPaid = sourceItem.type === 'paid';
                        var sourceRow = rowsBySourceIndex[sourceItem.sourceIndex]
                            || createRowFromSerpItem(sourceItem);
                        if (isPaid && Number(vm.query.deviceId) !== 2 && isRightSideItem(sourceItem)) {
                            sideItems.push({
                                kind: 'result',
                                sequence: sourceItem.sourceIndex,
                                row: sourceRow
                            });
                            continue;
                        }
                        if (isPaid) {
                            sponsoredRows.push(sourceRow);
                            continue;
                        }
                        flow.push({
                            kind: 'result',
                            order: getSerpItemOrder(sourceRow),
                            sequence: sourceItem.sourceIndex,
                            row: sourceRow
                        });
                        continue;
                    }

                    renderedFeatures.push(sourceItem);
                    flow.push({
                        kind: 'feature',
                        order: getFeatureOrder(sourceItem, fallbackFeaturePositions),
                        sequence: getSourceIndex(sourceItem),
                        feature: sourceItem
                    });
                }
            } else {
                paidRows.forEach(function (row) {
                    if (Number(vm.query.deviceId) !== 2 && isRightSideItem(row.extraParams && row.extraParams.snapshotData)) {
                        sideItems.push({
                            kind: 'result',
                            sequence: getSerpItemSequence(row),
                            row: row
                        });
                    } else {
                        sponsoredRows.push(row);
                    }
                });

                organicRows.forEach(function (row) {
                    flow.push({
                        kind: 'result',
                        order: getSerpItemOrder(row),
                        sequence: getSerpItemSequence(row),
                        row: row
                    });
                });

                features.forEach(function (feature) {
                    if (!feature || feature.type === 'knowledge_graph') {
                        return;
                    }
                    if (feature.type === 'ai_overview' && !aiOverviewFeature) {
                        aiOverviewFeature = feature;
                        return;
                    }
                    renderedFeatures.push(feature);
                    flow.push({
                        kind: 'feature',
                        order: getFeatureOrder(feature, fallbackFeaturePositions),
                        sequence: typeof feature.sourceIndex === 'number' ? feature.sourceIndex : 999,
                        feature: feature
                    });
                });
            }

            if (!sourceItems) {
                flow.sort(function (left, right) {
                    if (left.sequence === right.sequence) {
                        return left.order - right.order;
                    }
                    return left.sequence - right.sequence;
                });
            }

            var peopleAlsoAsk = renderedFeatures.find(function (feature) {
                return feature.type === 'people_also_ask';
            });
            var questions = peopleAlsoAsk && peopleAlsoAsk.items && peopleAlsoAsk.items.length
                ? peopleAlsoAsk.items.map(function (item) {
                    return item.title || item.description;
                }).filter(Boolean)
                : organicRows.slice(2, 6).map(function (row) {
                    return row.title;
                });

            vm.serpSimulation = {
                flow: flow,
                organicCount: flow.filter(function (item) {
                    return item.kind === 'result'
                        && item.row.resultType === 'organic';
                }).length,
                featureCount: flow.filter(function (item) {
                    return item.kind === 'feature';
                }).length + (aiOverviewFeature ? 1 : 0),
                knowledgeFeature: knowledgeFeature || null,
                aiOverview: aiOverviewFeature,
                sideItems: sideItems,
                sponsoredRows: sponsoredRows,
                questions: questions
            };
            vm.isAiOverviewExpanded = false;
            vm.aiOverviewHasOverflow = false;
            vm.localPackExpanded = false;
            $timeout(updateSerpOverflowStates, 0);
        }

        function toggleSponsoredResults() {
            vm.showSponsoredResults = !vm.showSponsoredResults;
        }

        function isRightSideItem(item) {
            return (item && item.position === 'right')
                || (item && item.data && item.data.position === 'right');
        }

        function getSourceIndex(item) {
            if (item && typeof item.sourceIndex === 'number') {
                return item.sourceIndex;
            }
            return Number(item && item.rankAbsolute) || 999;
        }

        function mergeLocalPackItems(localPacks) {
            var mergedItems = [];
            localPacks.forEach(function (localPack) {
                if (localPack.items && localPack.items.length) {
                    mergedItems = mergedItems.concat(localPack.items);
                } else {
                    mergedItems.push(localPack);
                }
            });

            return {
                type: 'local_pack',
                title: '',
                sourceIndex: getSourceIndex(localPacks[0]),
                sourceIndexes: localPacks.map(getSourceIndex),
                rankAbsolute: Number(localPacks[0].rankAbsolute) || null,
                rankGroup: Number(localPacks[0].rankGroup) || null,
                items: mergedItems,
                data: localPacks[0].data || {}
            };
        }

        function createRowFromSerpItem(item) {
            var metrics = item.metrics || {};
            return {
                link: {
                    url: item.url || null
                },
                resultType: item.type,
                position: Number(item.rankGroup) || null,
                rankPosition: Number(item.rankAbsolute) || null,
                title: item.title || '',
                breadcrumb: item.data && item.data.breadcrumb ? item.data.breadcrumb : '',
                description: item.description || '',
                extraParams: {
                    serpItemIndex: item.sourceIndex,
                    snapshotData: item.data || {},
                    backlinks: metrics.backlinks,
                    refdomains: metrics.referringDomains,
                    estimatedVisits: metrics.traffic,
                    ctr: metrics.ctr,
                    serpFeaturesAbove: metrics.featuresAbove
                }
            };
        }

        function getSerpItemOrder(row) {
            if (row && Number(row.rankPosition) > 0) {
                return Number(row.rankPosition);
            }
            if (row && row.extraParams && typeof row.extraParams.serpItemIndex === 'number') {
                return row.extraParams.serpItemIndex;
            }
            return Number(row && (row.rankPosition || row.position)) || 999;
        }

        function getFeatureOrder(feature, fallbackFeaturePositions) {
            if (feature && Number(feature.rankAbsolute) > 0) {
                return Number(feature.rankAbsolute);
            }
            if (feature && typeof feature.sourceIndex === 'number') {
                return feature.sourceIndex;
            }
            return Number(feature && (feature.rankAbsolute || feature.rankGroup))
                || fallbackFeaturePositions[feature.type]
                || 999;
        }

        function getSerpItemSequence(row) {
            return row && row.extraParams && typeof row.extraParams.serpItemIndex === 'number'
                ? row.extraParams.serpItemIndex
                : Number(row && row.position) || 999;
        }

        function applyMetricRatings(rows) {
            var definitions = {
                pa: function (row) {
                    return row.link && (row.link.pageAuthority || row.link.authority);
                },
                da: function (row) {
                    return row.link && row.link.domainAuthority;
                },
                links: function (row) {
                    return row.extraParams && row.extraParams.backlinks;
                },
                domains: function (row) {
                    return row.extraParams && row.extraParams.refdomains;
                },
                traffic: function (row) {
                    return row.extraParams && row.extraParams.estimatedVisits;
                }
            };
            var distributions = {};

            Object.keys(definitions).forEach(function (column) {
                distributions[column] = rows
                    .map(definitions[column])
                    .filter(hasValue)
                    .map(Number)
                    .sort(function (left, right) {
                        return left - right;
                    });
            });

            rows.forEach(function (row) {
                row._metricRatings = {};
                Object.keys(definitions).forEach(function (column) {
                    var value = definitions[column](row);
                    if (!hasValue(value) || !distributions[column].length) {
                        row._metricRatings[column] = '';
                        return;
                    }
                    var position = distributions[column].filter(function (candidate) {
                        return candidate <= Number(value);
                    }).length / distributions[column].length;
                    var isCompetitionMetric = column === 'pa' || column === 'da';
                    row._metricRatings[column] = ratingClass(position, isCompetitionMetric);
                });
            });
        }

        function applyAiCitationMetricRatings() {
            var syntheticRows = (vm.aiOverviewCitations || []).map(function (citation) {
                return {
                    link: {
                        pageAuthority: citation.pageAuthority,
                        domainAuthority: citation.domainAuthority,
                    },
                    extraParams: {
                        backlinks: citation.backlinks,
                        refdomains: citation.referringDomains,
                    },
                };
            });
            applyMetricRatings(syntheticRows);
            syntheticRows.forEach(function (row, index) {
                vm.aiOverviewCitations[index]._metricRatings = row._metricRatings;
            });
        }

        function getAiCitationMetricRating(column, citation) {
            if (!citation) {
                return '';
            }
            return citation._metricRatings && citation._metricRatings[column]
                ? citation._metricRatings[column]
                : '';
        }

        function getAiCitationCtr(citation) {
            if (!citation) {
                return null;
            }
            if (hasValue(citation.estimatedCtr)) {
                return Number(citation.estimatedCtr);
            }
            if (hasValue(citation.estimatedClicksShare)) {
                return Number((Number(citation.estimatedClicksShare) * 1).toFixed(2));
            }
            return null;
        }

        function getAiCitationClicks(citation) {
            if (!citation) {
                return null;
            }
            if (citation.estimatedClicksModel === 'ai-overview-citation-v2') {
                return citation.estimatedClicks;
            }
            if (hasValue(citation.estimatedClicksShare) && hasValue(vm.avgVolume)) {
                return Math.max(
                    1,
                    Math.round(Number(vm.avgVolume) * 0.01 * Number(citation.estimatedClicksShare))
                );
            }
            return citation.estimatedClicks;
        }

        function getAiOverviewEstimatedClicks() {
            var total = (vm.aiOverviewCitations || []).reduce(function (sum, citation) {
                var clicks = getAiCitationClicks(citation);
                return sum + (hasValue(clicks) ? Number(clicks) : 0);
            }, 0);
            return total > 0 ? total : null;
        }

        function getSerpEstimatedClicks() {
            var rows = vm.results && vm.results.rows ? vm.results.rows : [];
            var total = rows.reduce(function (sum, row) {
                var clicks = row && row.extraParams && row.extraParams.estimatedVisits;
                return sum + (hasValue(clicks) ? Number(clicks) : 0);
            }, 0);
            return total > 0 ? total : null;
        }

        function ratingClass(position, reverse) {
            if (reverse) {
                if (position >= .75) return 'rating-critical';
                if (position >= .5) return 'rating-warning';
                if (position >= .25) return 'rating-medium';
                return 'rating-good';
            }
            if (position >= .75) return 'rating-good';
            if (position >= .5) return 'rating-medium';
            if (position >= .25) return 'rating-warning';
            return 'rating-critical';
        }

        function getMetricRating(column, row) {
            if (row && row._metricRatings && row._metricRatings[column]) {
                return row._metricRatings[column];
            }
            var value;
            if (column === 'pa') {
                value = row.link && (row.link.pageAuthority || row.link.authority);
            } else if (column === 'da') {
                value = row.link && row.link.domainAuthority;
            } else if (row.extraParams) {
                var field = column === 'domains'
                    ? 'refdomains'
                    : column === 'traffic'
                        ? 'estimatedVisits'
                        : column === 'links'
                            ? 'backlinks'
                            : column;
                value = row.extraParams[field];
            }
            if (!hasValue(value)) {
                return '';
            }
            if (column === 'pa' || column === 'da') {
                return Number(value) >= 70 ? 'rating-critical'
                    : Number(value) >= 45 ? 'rating-warning'
                        : Number(value) >= 25 ? 'rating-medium' : 'rating-good';
            }
            return Number(value) > 0 ? 'rating-medium' : 'rating-critical';
        }

        function competitorsBacklinkAnalysis() {

            if (!vm.query || !vm.query.benchmark || !vm.query.benchmark.length) {
                vm.results.fixedRows = [];
                vm.results.competitorsRowsAreLoading = false;
                return;
            }
            vm.results.competitorsRowsAreLoading = true;
            SERPChecker.analyzeBacklinkFromURLs({
                urls: vm.query.benchmark,
                forceStatisticsUsingCachedSERP: vm.results.rows
            }).then(function (competitorsResponse) {
                vm.results.fixedRows = competitorsResponse.data.rows;
                vm.results.competitorsRowsAreLoading = false;
            }).catch(function (err) {
                vm.results.competitorsRowsAreLoading = false;
                vm.results.fixedRows = [];
            });
        }


        function analysis(currentRequestParams) {
            vm.results.messages.onBoarding = null;
            if (!angular.equals(currentRequestParams, lastRequestParams))
                return;
            SERPChecker.analyzeQueryBacklink(currentRequestParams)
                .then(function (serpAnalysisResults) {
                    TrackEventService.event(
                        'Suite Usages',
                        'SERP Checker - Audit', 'Backlink');
                    TrackEventService.gaV2Event(
                        'serp_audit',{
                            type: "Backlink",
                            tool: "SERP Checker"
                        });
                    if (angular.equals(currentRequestParams, lastRequestParams)) {

                        vm.results.isLoading = false;
                        vm.results.rows = serpAnalysisResults.data.rows;
                        vm.results.export.data = ExportService.convertObjectToCsvArray(setRowsForExportCSV(vm.results.rows));
                        vm.results.export.buttonDisabled = false;
                        vm.backlinksAvg = serpAnalysisResults.data.details.backlinksAvg;
                        vm.searchResults = serpAnalysisResults.data.details.totalRows;
                        vm.serpFeaturesList = serpAnalysisResults.data.details.resultTypes;
                        vm.serpFeaturePositions = serpAnalysisResults.data.details.resultFeatures
                            || serpAnalysisResults.data.details.serpItems
                            || [];
                        vm.serpSnapshotItems = serpAnalysisResults.data.details.serpSnapshot
                            || serpAnalysisResults.data.serpSnapshot
                            || [];
                        vm.dataForSeoResult = serpAnalysisResults.data.dataForSeo
                            || serpAnalysisResults.data.details.dataForSeoResult
                            || null;
                        vm.aiOverviewCitations = (
                            serpAnalysisResults.data.aiOverview
                            && serpAnalysisResults.data.aiOverview.citations
                        ) || serpAnalysisResults.data.details.aiOverviewCitations || [];
                        applyAiCitationMetricRatings();
                        buildSerpSimulation(
                            vm.results.rows,
                            vm.serpFeaturePositions,
                            serpAnalysisResults.data.details.serpItems || []
                        );
                        vm.avgDifficulty = serpAnalysisResults.data.details.avgDifficulty;
                        vm.avgVolume = serpAnalysisResults.data.details.avgVolume;
                        vm.backlinksTotal = serpAnalysisResults.data.details.backlinksTotal;
                        vm.backlinksNoFollow = serpAnalysisResults.data.details.backlinksNoFollow;
                        vm.backlinksDoFollow = serpAnalysisResults.data.details.backlinksDoFollow;
                        vm.backlinksDoFollowPercent = vm.backlinksTotal > 0
                            ? Math.ceil(vm.backlinksDoFollow * 100 / vm.backlinksTotal)
                            : null;
                        vm.avgRefDomains = serpAnalysisResults.data.details.avgRefDomains;
                        competitorsBacklinkAnalysis();

                    }
                })
                .catch(function (err) {
                    if (angular.equals(currentRequestParams, lastRequestParams)) {
                        vm.results.isLoading = false;
                        vm.results.rows = [];
                        vm.results.fixedRows = [];

                        if (err.status === 429 || err.status === 426) {
                            vm.results.messageWhenEmptyDataTitle = stLimitMessage.getFromError(err, userInfo).title;
                            vm.results.messageWhenEmptyDataSubtitle = stLimitMessage.getFromError(err, userInfo).subtitle;
                            vm.results.messageWhenEmptyDataIcon = stLimitMessage.getFromError(err, userInfo).icon;
                            vm.results.messageWhenEmptyDataCta = stLimitMessage.getFromError(err, userInfo).cta;
                            //injected manually to get around circular dependency problem.
                            err.data.canClose = true;
                            stAlertLimitService.open('auth-login', err.data);
                        }
                    }
                });
        }

        function newAnalysis() {
            if (lastRequestDone === JSON.stringify(currentQueryParams)) {
                return;
            }
            if (!currentQueryParams.keyword) {
                return;
            }
            var currentRequestParams = SERPChecker.castQueryToAPIFormat(currentQueryParams);
            if (JSON.stringify(currentRequestParams) === JSON.stringify(lastRequestParams))
                return;
            lastRequestDone = JSON.stringify(currentQueryParams);
            lastRequestParams = SERPChecker.castQueryToAPIFormat(currentQueryParams);
            setLoadingState();
            analysis(currentRequestParams);
        }


        function isString(value) {
            return typeof value === 'string';
        }

        function setEventsListeners() {
            vm.$on('SERPCheckerAudit', function (evt, query) {
                if (query) {
                    vm.query = query;
                }

                newAnalysis();
            });
            vm.$on('SERPCheckerAuditCompetitors', function (evt, query) {
                if (query) {
                    vm.query = query;
                }

                competitorsBacklinkAnalysis();
            });
        }

        _constructor();

    }

    Controller.$inject = ['$scope', 'UserService', 'stAlertLimitService', 'stLimitMessage', 'userInfo', 'ExportService', '$translate', '$filter', '__env', '$timeout', '$sce', '$mdDialog', 'SerpCTRService', 'SerpCheckerService', '$stateParams', 'TrackEventService'];
    return Controller;
});
